import React from "react";
import { motion } from "framer-motion";
import "./AuthorCard.css"; // Add this import

const AuthorCard = ({ author }) => {
  return (
    <div className="author-card">
      <div className="author-card-content">
        <img
          src={author.image}
          alt={author.name}
          className="author-card-image"
        />
        <div>
          <div className="author-card-header">
            <h3 className="author-card-name">{author.name}</h3>
            {author.socialLinks && (
              <div className="social-links">
                {author.socialLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            )}
          </div>
          <div
            className="author-card-bio"
            dangerouslySetInnerHTML={{ __html: author.bio }}
          />
        </div>
      </div>
    </div>
  );
};
export default AuthorCard;
